/* @flow */

import { fromJS, List, Map } from 'immutable'
import { toCamelCase, toSnakeCase } from './string'
import type { DataType } from '../data_handler'

type MappingListType = List<DataType>
type MappingDataType = DataType | MappingListType | List<MappingListType>

const handleMap = (map: Object, reverse: boolean): Object => {
  if (reverse && map) {
    return Object.keys(map).reduce((obj, key) => {
      if (typeof map[key] == 'object') {
        const newKey = map[key]._key || (reverse ? toSnakeCase(key) : toCamelCase(key))
        obj[newKey] = Object.assign({}, map[key], { _key: key })
      } else {
        obj[map[key]] = key
      }
      return obj
    }, {})
  }
  return map || {}
}

/**
 * @param data Immutable.Map
 * @param mapping Object
 * @param reverse Boolean
 * @return Immutable.Map
 */
const useMapping = (data: MappingDataType, mapping: Object, reverse: boolean) => {
  if (List.isList(data)) {
    return ((data: any): MappingListType).map((entry) => {
      return useMapping(entry, mapping, reverse)
    })
  } else if (Map.isMap(data)) {
    const map = handleMap(mapping, reverse)
    data = ((data: any): DataType)
      .map((value, key) => {
        if (Map.isMap(value) || List.isList(value)) {
          return useMapping(((value: any): MappingDataType), map[key], reverse)
        }
        return value
      })
      .mapKeys((key) => {
        if (map[key] && map[key]._key) {
          return map[key]._key
        } else {
          return typeof map[key] == 'string' ? map[key] : reverse ? toCamelCase(key) : toSnakeCase(key)
        }
      })
  }
  return data
}

/**
 * @param mapping Object
 * @param json Object
 * @return Immutable.Map
 */
export const jsonToState = (mapping: Object) => (json: Object) => {
  return useMapping(((fromJS(json): any): DataType), mapping, true)
}

/**
 * @param mapping Object
 * @param store Immutable.Map
 * @return Object
 */
export const stateToJson = (mapping: Object) => (store: DataType) => {
  return useMapping(store, mapping, false).toJS()
}
